import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'
import { Box } from '@chakra-ui/react'

interface CustomIconProps extends IconProps {
  variant?: string
}

const UserCardsOutline = createIcon({
  displayName: 'UserCardsOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <rect width="24" height="24"></rect>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16.333 21h-11.666c-.921 0-1.667-.746-1.667-1.667v-11.666c0-.921.746-1.667 1.667-1.667h11.667c.92 0 1.666.746 1.666 1.667v11.667c0 .92-.746 1.666-1.667 1.666Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12.268 10.166c.976.976.976 2.559 0 3.536 -.976.976-2.559.976-3.536 0 -.977-.976-.976-2.559 0-3.536 .976-.977 2.559-.976 3.536 0"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15 18.434c-.131-.329-.334-.625-.594-.866v0c-.439-.408-1.014-.634-1.614-.634 -1 0-3.584 0-4.584 0 -.6 0-1.174.227-1.614.634v0c-.26.241-.463.537-.594.866"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6 6v-1.333c0-.921.746-1.667 1.667-1.667h11.667c.92 0 1.666.746 1.666 1.667v11.667c0 .92-.746 1.666-1.667 1.666h-1.333"
        ></path>
      </g>
    </>
  ),
})

const UserCardsTwoTone = createIcon({
  displayName: 'UserCardsTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none">
        <Box
          as="path"
          fill="twoToneLightColor"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6 6v-1.333c0-.921.746-1.667 1.667-1.667h11.667c.92 0 1.666.746 1.666 1.667v11.667c0 .92-.746 1.666-1.667 1.666h-1.333"
        ></Box>
        <Box
          as="path"
          fill="light"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16.333 21h-11.666c-.921 0-1.667-.746-1.667-1.667v-11.666c0-.921.746-1.667 1.667-1.667h11.667c.92 0 1.666.746 1.666 1.667v11.667c0 .92-.746 1.666-1.667 1.666Z"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12.268 10.166c.976.976.976 2.559 0 3.536 -.976.976-2.559.976-3.536 0 -.977-.976-.976-2.559 0-3.536 .976-.977 2.559-.976 3.536 0"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15 18.434c-.131-.329-.334-.625-.594-.866v0c-.439-.408-1.014-.634-1.614-.634 -1 0-3.584 0-4.584 0 -.6 0-1.174.227-1.614.634v0c-.26.241-.463.537-.594.866"
        ></Box>
      </Box>
    </>
  ),
})

const UserCards: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={UserCardsTwoTone} {...props} />

  return <CustomIcon as={UserCardsOutline} {...props} />
}

export default memo(UserCards)
